<template>
    <div class="f-scrolltop"
         v-bind:data-threshold="threshold"
         v-if="isShow"
         v-on:click="onClickHandle"></div>
</template>

<script>
    import utils from '../utils'

    export default {
        name: 'f-scrolltop',
        data () {
            return {
                isShow: false
            }
        },
        props: {
            threshold: {
                type: Number,
                default: 0
            }
        },
        watch: {
            isShow (val) {
                if (val) {
                    this.$emit('scroll-show')
                } else {
                    this.$emit('scroll-hide')
                }
            }
        },
        methods: {
            onClickHandle () {
                var self = this
                document.documentElement.scrollTop = document.body.scrollTop = 0
                setTimeout(function () {
                    self.$emit('scroll-end')
                }, 50)
            },
            init () {
                var self = this
                if (this.threshold > 0) {
                    var throttleScroll = utils.throttle(function (e) {
                        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
                        if (scrollTop >= self.threshold) {
                            self.isShow = true
                        } else {
                            self.isShow = false
                        }
                    }, 200)

                    window.addEventListener('scroll', function (e) {
                        throttleScroll(e)
                    })
                }
            }
        },

        mounted () {
            this.init()
        }
    }
</script>

<style lang="stylus">
    .f-scrolltop
        display: block
        position: fixed
        z-index: 999
        width: 45px
        height: 45px
        right: 14px
        bottom: 14px
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
        background: url(//cdn.upin.com/mfanhuan/images/sprite_gray.png) no-repeat
        background-size: 45px 45px
</style>


// WEBPACK FOOTER //
// scrolltop.vue?648fb985